import CellWrapper from '../cells/CellWrapper';
import { useMaterialsTableContext } from '../MaterialsTableContext';
import Icon from '@/ui/components/Icon';

const HeaderItem = ({ column, index }) => {
  const { activeColumn, handleActiveColumn } = useMaterialsTableContext();
  const iconName = column.isSortedDesc ? 'caret-down' : 'caret-up';

  const { key: headerKey, ...headerProps } = column.getHeaderProps(
    column.getSortByToggleProps()
  );

  return (
    <div
      key={headerKey}
      {...headerProps}
      className={`th${index === activeColumn ? ' active' : ''}`}
      onMouseEnter={() => handleActiveColumn(index)}
    >
      {/* <div>{column.canFilter ? column.render('Filter') : null}</div> */}
      {/* {column.canGroupBy ? (
        // If the column can be grouped, let's add a toggle
        <span {...column.getGroupByToggleProps()}>
          {column.isGrouped ? (
            <Icon name="compress" style="solid" />
          ) : (
            <Icon name="compress-arrows-alt" style="solid" />
          )}
          {/* style={{ marginRight: '0.5em' }} */}
      {/* </span> */}
      {/* ) : null} */}
      {/* TEXT */}
      <CellWrapper $header={true}>
        {column.render('Header')}
        {/* Add a sort direction indicator */}
        <span>
          {column.isSorted ? (
            <Icon
              name={iconName}
              style="solid"
              // style={{ fontSize: '1.2em' }}
            />
          ) : (
            ''
          )}
        </span>
      </CellWrapper>
    </div>
  );
};

const HeaderGroup = ({ headerGroup }) => {
  const { key: headerGroupKey, ...headerGroupProps } =
    headerGroup.getHeaderGroupProps();

  return (
    <div key={headerGroupKey} {...headerGroupProps} className="tr">
      {headerGroup.headers.map((column, index) => (
        <HeaderItem key={column.id} column={column} index={index} />
      ))}
    </div>
  );
};

export default function Header({ headerGroups }) {
  return (
    <div className="header">
      {headerGroups.map((headerGroup, index) => (
        <HeaderGroup key={`header-group-${index}`} headerGroup={headerGroup} />
      ))}
    </div>
  );
}
